(function () {
	jQuery.extend(jQuery.expr[':'], {
		focusable: function (el, index, selector) {
			return $(el).is('input[type="text"], input[type="password"], input[type="email"], button#signup-button');
		}
	});

	function MaterialForm(selector) {
		this.el = $(selector);

		this.passwordEl = $('#Passwd');

		this.revealPasswordToggleBtn = $('.reveal-password-toggle', this.el);

		this.passwordGuidelinesMobileEl = $('.show-pw-guidelines-mobile', this.el);

		this.cardLeftEl = $('#card-left');
		this.passwordGuidelinesEl = $('#password-guidelines');
		this.passwordRequirementsEl = $('#password-requirements');
		this.cardLeftContent = null;

		this.handleInputFocus = $.proxy(this.onInputFocus, this);
		this.handleInputBlur = $.proxy(this.onInputBlur, this);
		this.handleInputChange = $.proxy(this.onInputChange, this);
		this.handleRevealPasswordToggle = $.proxy(this.revealPasswordToggle, this);
		this.handleEnterKey = $.proxy(this.onEnterKey, this);
		this.togglePasswordGuidelinesMobile = $.proxy(this.togglePasswordGuidelinesMobile, this);

		this.init();
	}

	/**
	 * Selector used to identify text input elements.
	 * @type {String}
	 */
	MaterialForm.INPUT_SELECTOR = [
		'input[type="text"]',
		'input[type="password"]',
		'input[type="email"]'
	].join(', ');

	MaterialForm.prototype.init = function () {
		// Set default state for each element
		this.el.find(MaterialForm.INPUT_SELECTOR).each($.proxy(function (index, el) {
			this.updateInputState($(el));
		}, this));

		this.addEventListeners();
		this.initializeSelectize();

		setInterval(this.autofillFix, 100);
	};

	/**
	 * We need to apply autofill fix for the form to avoid situation when autofilled data
	 * is covered with form placeholders (actually our placeholders are css modified labels).
	 */
	MaterialForm.prototype.autofillFix = function () {
		const inputs = $('.pristine ' + MaterialForm.INPUT_SELECTOR);

		inputs.each(function () {
			const currentInput = $(this);
			const isCurrentInputEmpty = currentInput.val() === '';
			const isWebkitBrowser = 'webkitLineBreak' in document.documentElement.style;
			let isWebKitAutofilled = false;

			if (isCurrentInputEmpty && isWebkitBrowser) {
				isWebKitAutofilled = currentInput.is(':-webkit-autofill')
			}

			if (!isCurrentInputEmpty || isWebKitAutofilled) {
				currentInput.closest('.pristine').removeClass('pristine');
			}
		});
	};

	MaterialForm.prototype.addEventListeners = function () {
		this.el.on('focus', MaterialForm.INPUT_SELECTOR, this.handleInputFocus);
		this.el.on('blur', MaterialForm.INPUT_SELECTOR, this.handleInputBlur);
		this.el.on('keyup', MaterialForm.INPUT_SELECTOR, this.handleInputChange);
		this.revealPasswordToggleBtn.on('mousedown touchstart', this.handleRevealPasswordToggle);
		this.revealPasswordToggleBtn.on('click', (e) => e.preventDefault());
		this.el.on('keypress', 'input, select', this.handleEnterKey);
		this.passwordGuidelinesMobileEl.on('click', this.togglePasswordGuidelinesMobile);
	};

	MaterialForm.prototype.onInputFocus = function (event) {
		const el = $(event.currentTarget);

		// Ignore selectize input elements
		if (el.parent().hasClass('selectize-input')) {
			return;
		}

		this.updateInputState(el);
		el.parent().addClass('focus');

		if (el.is(this.passwordEl)) {
			this.showPasswordHelper();
		}
	};

	MaterialForm.prototype.onInputBlur = function (event) {
		const el = $(event.currentTarget);

		// Ignore selectize input elements
		if (el.parent().hasClass('selectize-input')) {
			return;
		}

		this.updateInputState(el);
		el.parent().removeClass('focus');

		if (el.is(this.passwordEl)) {
			this.hidePasswordHelper();
		}
	};

	MaterialForm.prototype.onInputChange = function (event) {
		const el = $(event.currentTarget);

		// Ignore selectize input elements
		if (el.parent().hasClass('selectize-input')) {
			return;
		}

		this.updateInputState(el);
	};

	MaterialForm.prototype.onEnterKey = function (event) {
		if (event.which === 13) {
			event.preventDefault();

			const focusableEls = $(':focusable');
			let index = focusableEls.index(event.currentTarget) + 1;

			if (index >= focusableEls.length) {
				index = 0;
			}

			focusableEls.eq(index).focus();
		}
	};

	MaterialForm.prototype.updateInputState = function (el) {
		if (el.val()) {
			el.parents('.material-form-group').removeClass('pristine');
		} else {
			el.parents('.material-form-group').addClass('pristine');
		}
	};

	MaterialForm.prototype.showPasswordHelper = function () {
		if (this.cardLeftContent === null) {
			this.cardLeftContent = this.cardLeftEl.children();
		}
		if (this.passwordRequirementsEl.length) {
			this.cardLeftEl.html(this.passwordRequirementsEl.children().clone());
		} else {
			this.cardLeftEl.html(this.passwordGuidelinesEl.children().clone());
		}
	};

	MaterialForm.prototype.hidePasswordHelper = function () {
		if (this.cardLeftContent) {
			this.cardLeftEl.html(this.cardLeftContent);
		}
	};

	MaterialForm.prototype.revealPasswordToggle = function (event) {
		event.preventDefault();

		const el = this.passwordEl;
		const btn = this.revealPasswordToggleBtn;

		if (el.attr('type') === 'password') {
			el.attr('type', 'text');
			btn.addClass('js-show').text('Hide');
		} else {
			el.attr('type', 'password');
			btn.removeClass('js-show').text('Show');
		}

		this.passwordEl.focus();

		return false;
	};

	MaterialForm.prototype.initializeSelectize = function () {
		$('.render-after-init', this.el).each(function () {
			$(this).replaceWith($(this).html());
		});

		const selectEls = this.el.find('select');

		selectEls.parents('.material-form-group').addClass('pristine');

		selectEls.selectize({
			onChange: function (value) {
				this.$input.parents('.material-form-group').removeClass('pristine');
			},
			onBlur: function () {
				if (!this.getValue()) {
					this.$input.parents('.material-form-group').addClass('pristine');
				}
			},
			onDropdownOpen: function () {
				this.$input.parents('.material-form-group').removeClass('pristine');
			},
			searchField: ['text', 'value'],
			selectOnTab: true,
		});
	};

	MaterialForm.prototype.togglePasswordGuidelinesMobile = function () {
		this.passwordGuidelinesEl.toggle();
	};

	$(function () {
		new MaterialForm('.material-form');
	})
})();



// WEBPACK FOOTER //
// ./src/js/material-form.js